import { Card } from '../models/card.interfaces';

export const BaseCardMocks: Card = {
  id: 'earnMilesWithLyft',
  type: 'base',
  content: {
    title: 'Earn Miles With Lyft',
    subtitle: 'Earn 2 miles per $1 on all U.S. airport rides'
  },
  image: {
    src: 'http://placeimg.com/82/82/tech',
    alt: 'Earn Miles With Lyft'
  },
  tag: {
    title: 'LIMITED TIME OFFER'
  },
  action: {
    type: 'text',
    link: {
      label: 'More Details',
      url: 'https://www.deltalyft.com/content/delta-lyft/en/terms-and-conditions.html'
    }
  }
};

export const SmallCardMocks: Card[] = [
  {
    id: 'skyMilesDigitalCard',
    type: 'small',
    content: {
      title: 'SkyMiles Digital Card'
    },
    image: {
      src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/cards/digital-card-skymiles.png',
      alt: 'SkyMiles Digital Card'
    },
    tag: {
      title: 'SKYMILES MEMBER',
      subtitle: '#9876543210'
    },
    action: {
      type: 'text',
      link: {
        label: 'View / Print',
        url: '#'
      }
    }
  },
  {
    id: 'skyClubMembershipCard',
    type: 'small',
    content: {
      title: 'Manage SkyClub Membership'
    },
    image: {
      src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/cards/skyclub-membership-card.png',
      alt: 'SkyClub Membership Card Image'
    },
    tag: {
      title: 'Individual Membership',
      subtitle: 'Current Term Expires 09/29/25'
    },
    action: {
      type: 'text',
      link: {
        label: 'View / Print',
        url: '#'
      }
    }
  }
];

export const BaseCardMocksWith2Images: Card = {
  ...BaseCardMocks,
  image2: {
    src: 'http://placeimg.com/82/82/tech',
    alt: 'Earn Miles With Lyft',
    show: true
  }
};
